module.exports = __webpack_public_path__ + "img/chicken-tortilla.28168994.png";